import BaseComponent from '../abstracts/BaseComponent';

const debug = false;

export default class SocialSharing extends BaseComponent {

  constructor(element) {
    super(element);

    debug && console.log('SocialSharing', this.$options);

    let shareData = {
      title: this.$options.title,
      // text: this.$options.text,
      url: this.$options.url,
    }
  
    const canShare = navigator.canShare;
    if (canShare) {
      this.$el.classList.add('navigator-can-share');
      const btn = this.$el.querySelector('.social-sharing-button');
      btn.addEventListener('click', () => {
        navigator.share(shareData)
          .then(() => {
            // resultPara.textContent = 'MDN shared successfully'
          })
          .catch((e) => {
            // resultPara.textContent = 'Error: ' + e
          });
      });
    }

    this.$el.querySelector('.icon-copylink').addEventListener('click', async e => {
      e.preventDefault();
      const target = e.currentTarget;
      await navigator.clipboard.writeText(target.dataset.url);
      target.classList.add('copied');
      setTimeout(() => target.classList.remove('copied'), 1000);
    });
  }
}
